var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DixaIcon from '@dixa/dixa-modern-icons';
import { Tooltip } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import classnames from 'classnames';
import { Component } from 'react';
import { ConversationListItem } from './conversationListItem';
import styles from './conversations.module.scss';
export class Conversations extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showAllConversations: false,
        };
        this.toggleConversationShow = this.toggleConversationShow.bind(this);
    }
    toggleConversationShow() {
        this.setState({ showAllConversations: !this.state.showAllConversations });
    }
    renderListItems(currentMetaConv, listIndex) {
        const { typings, conversationsRemove, typingRemove, wsRequest, isMenuOpen, conversationsLastSearchParams, onToggleNavigation, } = this.props;
        if (!currentMetaConv) {
            return null;
        }
        const conversationTyping = typings.find((typing) => typing.csid === currentMetaConv.conversation.id);
        return (_jsx(ConversationListItem, { listIndex: listIndex, conversationsLastSearchParams: conversationsLastSearchParams, isMenuOpen: isMenuOpen, isViewingConversation: window.location.pathname ===
                `${BASEPATH}conversation/${currentMetaConv.conversation.id}`, conversationsRemove: conversationsRemove, typingRemove: typingRemove, wsRequest: wsRequest, typing: conversationTyping, metaConversation: currentMetaConv, onToggleNavigation: onToggleNavigation }, currentMetaConv.conversation.id));
    }
    renderShowMoreOrLess() {
        const { metaConversationsAfterBreak, isMenuOpen } = this.props;
        const { showAllConversations } = this.state;
        if (isMenuOpen) {
            return showAllConversations ? (_jsx("span", { children: "Show less" })) : (_jsxs("span", { children: ["Show more (", metaConversationsAfterBreak.length, ")"] }));
        }
        return (_jsx(DixaIcon, { icon: showAllConversations ? 'minus' : 'dots', className: styles.showMoreOrLessIcon }));
    }
    render() {
        const { metaConversationsBeforeBreak, metaConversationsAfterBreak, isMenuOpen, } = this.props;
        const { showAllConversations } = this.state;
        const renderedConversations = showAllConversations
            ? metaConversationsBeforeBreak.concat(metaConversationsAfterBreak)
            : metaConversationsBeforeBreak;
        const rootClass = classnames({
            [styles.root]: true,
            [styles.rootCollapsed]: !isMenuOpen,
        });
        return (_jsxs("ul", Object.assign({ className: rootClass }, { children: [renderedConversations.map((metaConversation, index) => this.renderListItems(metaConversation, index)), metaConversationsAfterBreak.length > 0 && (_jsx("li", Object.assign({ className: styles.listItem }, { children: _jsx(Tooltip, Object.assign({ content: showAllConversations ? 'Show less' : 'Show more', dark: true, disabled: isMenuOpen }, { children: _jsx("button", Object.assign({ onClick: this.toggleConversationShow, className: styles.showMoreOrLess }, { children: this.renderShowMoreOrLess() })) })) })))] })));
    }
}
__decorate([
    boundMethod
], Conversations.prototype, "renderListItems", null);
